/**
 * sd-about-page.js — IntersectionObserver reveal for the About page.
 * Recipe #1, JS-first, all browsers. No animation-timeline.
 */
import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class SdAboutPage extends Component {
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) {
      this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }
    this.#io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.#io?.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -6% 0px' }
    );
    this.querySelectorAll('.reveal').forEach((el) => this.#io.observe(el));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }
}

if (!customElements.get('sd-about-page')) {
  customElements.define('sd-about-page', SdAboutPage);
}
